import { Injectable, inject } from "@angular/core";
import { Question } from "../classes/flow/Questionnaire/Question";
import { EpfService } from "./epf.service";

@Injectable({
  providedIn: "root",
})
export class ReportService {
  private epf = inject(EpfService);

  private getAllQuestionsWithAnswers(questions: Question[]): Question[] {
    questions = questions.filter((question) => question.answer);
    questions.forEach((question) => (question.followUpQuestions = this.getAllQuestionsWithAnswers(question.followUpQuestions)));
    return questions;
  }

  public async getPdfFile(requestId: number): Promise<string | null> {
    const res = await this.epf.reportAsPdf(requestId);
    return res;
  }
}
